<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title eng="USER GUIDE" :jpn="t('ご利用ガイド')" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('購入にあたって')"
        >
          <div class="text-container">
            <span class="text">
              {{t('１.ログイン頂いた状態で、ポイント購入画面からポイントをご購入ください。')}}
            </span>
            <span class="text">
              {{t('お支払いが完了いたしましたら、画面上の数字が変動いたします。')}}
            </span>
            <span class="text">
              {{t('※銀行振込などの場合は、ご入金を確認させて頂き次第の反映となります。')}}
            </span>
            <span class="text">
              {{ t('そのため反映まで最大数日かかる場合がございますこと、予めご容赦くださいませ。') }}
            </span>
            <br>
            <span class="text center">
              ↓
            </span>
            <br>
            <span class="text">
              {{t('２.購入したい商品を全て選び終えましたら、購入手続きに進んで下さい。')}}
            </span>
            <br>
            <span class="text center">
              ↓
            </span>
            <br>
            <span class="text">
              {{t('３.購入いただいた商品が一覧で表示されます。')}}
            </span>
            <span class="text">
              {{t('その中から、「発送希望商品」と「ポイントへ還元する商品」を24時間以内にご選択ください。')}}
            </span>
            <span class="text">
              {{t('24時間を過ぎますと、自動で購入いただいた商品が全てポイントに還元されます。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="お支払いについて"
          id="howtopay"
        >
          <div class="text-container">
            <span class="text">
              ・各種クレジットカード
            </span>
            <span class="text" v-if="i18n_mode == 'jp'">
              ・コンビニエンスストア払い
            </span>
            <span class="text" v-if="i18n_mode == 'jp'">
              ・Amazon Pay
            </span>
            <span class="text" v-if="i18n_mode == 'jp'">
              ・キャリア決済
            </span>
            <span class="text" v-if="i18n_mode == 'jp'">
              ・メルペイ
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('発送日')"
          id="howtosend"
        >
          <div class="text-container">
            <span class="text">
              {{t('原則、ご利用日から3日〜14日以内の発送となります。')}}<br>
              {{t('※送料が無料のため、複数回ご利用頂いた場合は全てまとめて発送いたします。')}}<br>
              <br>
              {{t('以下に配送等への留意事項を記載させて頂きます。')}}<br>
              <br>
              {{t('【留意事項等】')}}<br>
              <br>
              {{t('※クレジットカードによる不正決済防止のため、ご本人様確認や調査をおこなわせて頂くことがございます。')}}<br>
              {{t('(その場合、発送までにお時間がかかる場合がございます)')}}<br>
              <span v-if="i18n_mode == 'jp'">{{t('※発送日等へのお問い合わせにはご対応致しかねます。')}}<br></span>
              <span v-if="i18n_mode == 'jp'">
                {{t('※発送前の状態確認で看過できない傷等があった際には、発送までにお時間を頂戴することがございます。')}}<br>
              </span>
              {{t('(発送完了次第、発送通知の上、追跡番号を反映いたします)')}}<br>
              {{t('※発送件数が多い時や、業務上過多の際は、上記期日を超える場合がございます。')}}<br>
              <span v-if="i18n_mode == 'jp'">
                {{t('※16時半以降の発送通知に記載の追跡反映は翌夕方頃の反映になる場合がございます。')}}<br>
              </span>
              {{t('※ご登録先のご住所等に誤りがあった場合には、正しく発送されない場合がございます。')}}
              <br>
              {{t('弊社では対応できかねますので、正しいご住所を予めご登録ください。')}}
              <br>
              {{t('(尚、その際は一切の責任等を負いかねます)')}}
              <br>
              {{t('(弊社まで差し戻しとなった商品の再発送はおこなわず、返金等もいたしかねます)')}}
              <br>
              <span v-if="i18n_mode == 'jp'">
                本件においてのご質問等は、
                <a href="https://www.iranoan.com/contacts" target="_blank">minny通販店</a>
                よりお願いいたします。
              </span>
              <span v-else>
                If you have any questions about this matter,
                <a href="https://www.iranoan.com/contacts" target="_blank">please use the "chat" or "inquiry form"</a>
                of the minny mail order store.
              </span>
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('消費税について')"
        >
          <div class="text-container">
            <span class="text">
              {{t('表示されている金額は全て税込(10%)となります。')}}
            </span>
            <span class="text">
              {{t('(1円未満は四捨五入)')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'UserGuide',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: #4a3f3a;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: $black;
          a {
            color: $black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
  .center {
    text-align: left;
  }
}
</style>
